<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración de Menús</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Administración de Menús</h1>

<div style="display: flex; gap: 24px; flex-wrap: wrap;">

  <!-- ====== CATÁLOGO DE MENÚS ====== -->
  <div style="flex: 1; min-width: 400px;">
    <panel [noButton]="true">
      <div header class="d-flex justify-content-between align-items-center w-100">
        <span class="fs-4 fw-700"><i class="fas fa-list"></i> Catálogo de Menús</span>
        <button class="btn btn-primary btn-sm" (click)="open(modalMenu)">+ Nuevo Menú</button>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th class="text-center" style="width: 30px;">N°</th>
              <th>Título</th>
              <th>Icono</th>
              <th>URL</th>
              <th>Submenú de</th>
              <th class="text-center">Orden</th>
              <th class="text-center"><i class="fas fa-cogs"></i></th>
            </tr>
          </thead>
          <tbody>
            @for(menu of catalogo; track menu._id; let im = $index){
            <tr>
              <td class="text-center">{{ im + 1 }}</td>
              <td><strong>{{ menu.title }}</strong></td>
              <td><i [class]="menu.icon"></i></td>
              <td style="color:#6366f1;">{{ menu.url }}</td>
              <td>—</td>
              <td class="text-center" style="white-space: nowrap;">
                <button class="btn btn-xs btn-secondary mx-1" (click)="moveUp(menu)" [disabled]="im === 0" ngbTooltip="Subir"><i class="fas fa-angle-up"></i></button>
                <button class="btn btn-xs btn-secondary mx-1" (click)="moveDown(menu)" [disabled]="im === catalogo.length - 1" ngbTooltip="Bajar"><i class="fas fa-angle-down"></i></button>
              </td>
              <td class="text-center" style="white-space: nowrap;">
                <button class="btn btn-xs btn-primary mx-1" (click)="open(modalMenu, menu)" ngbTooltip="Editar"><i class="fas fa-edit"></i></button>
                <button class="btn btn-xs btn-danger mx-1" (click)="deleteMenu(menu._id)" ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            @for(sub of menu.submenu; track sub._id; let is = $index){
            <tr>
              <td style="padding-left: 24px;">{{ im + 1 }}.{{ is + 1 }}</td>
              <td>{{ sub.title }}</td>
              <td><i [class]="sub.icon"></i></td>
              <td style="color:#6366f1;">{{ sub.url }}</td>
              <td>{{ menu.title }}</td>
              <td class="text-center" style="white-space: nowrap;">
                <button class="btn btn-xs btn-secondary mx-1" (click)="moveUp(sub, menu)" [disabled]="is === 0" ngbTooltip="Subir"><i class="fas fa-angle-up"></i></button>
                <button class="btn btn-xs btn-secondary mx-1" (click)="moveDown(sub, menu)" [disabled]="is === menu.submenu.length - 1" ngbTooltip="Bajar"><i class="fas fa-angle-down"></i></button>
              </td>
              <td class="text-center" style="white-space: nowrap;">
                <button class="btn btn-xs btn-primary mx-1" (click)="open(modalMenu, sub)" ngbTooltip="Editar"><i class="fas fa-edit"></i></button>
                <button class="btn btn-xs btn-danger mx-1" (click)="deleteMenu(sub._id)" ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            }
            }
            @empty {
            <tr>
              <td colspan="7" class="text-center">No hay menús registrados</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </panel>
  </div>

  <!-- ====== ASIGNACIÓN POR ROL ====== -->
  <div style="flex: 1; min-width: 400px;">
    <panel [noButton]="true">
      <div header>
        <span class="fs-4 fw-700"><i class="fas fa-link"></i> Asignación por Rol</span>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label fw-600">Seleccionar Rol</label>
          <ng-select [items]="roles" bindLabel="name" bindValue="_id" [(ngModel)]="selectedRoleId"
            (change)="getRoleMenu()" [clearable]="false"></ng-select>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th class="text-center" style="width: 30px;">N°</th>
              <th>Icono</th>
              <th>Menú</th>
              <th>Ruta</th>
              <th class="text-center">Habilitado</th>
            </tr>
          </thead>
          <tbody>
            @for(menu of assignedMenus; track menu._id; let im = $index){
            <tr>
              <td class="text-center">{{ im + 1 }}</td>
              <td><i [class]="menu.icon"></i></td>
              <td><strong>{{ menu.title }}</strong></td>
              <td style="color:#6366f1;">{{ menu.url }}</td>
              <td class="text-center">
                <div class="form-check form-switch d-flex justify-content-center">
                  <input class="form-check-input" type="checkbox" [checked]="getEnabled(menu._id)"
                    (change)="toggleMenu(menu._id, !getEnabled(menu._id))" />
                </div>
              </td>
            </tr>
            @for(sub of menu.submenu; track sub._id; let is = $index){
            <tr>
              <td style="padding-left: 24px;">{{ im + 1 }}.{{ is + 1 }}</td>
              <td><i [class]="sub.icon"></i></td>
              <td>{{ sub.title }}</td>
              <td style="color:#6366f1;">{{ sub.url }}</td>
              <td class="text-center">
                <div class="form-check form-switch d-flex justify-content-center">
                  <input class="form-check-input" type="checkbox" [checked]="getEnabled(sub._id)"
                    (change)="toggleMenu(sub._id, !getEnabled(sub._id))" />
                </div>
              </td>
            </tr>
            }
            }
            @empty {
            <tr>
              <td colspan="5" class="text-center">Seleccione un rol para ver sus menús asignados</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="mt-2 text-muted small">
        <i class="fas fa-info-circle"></i> Rol: <strong>{{ selectedRoleName }}</strong> — {{ getEnabledCount() }} de {{ assignedMenus.length }} menús habilitados
      </div>
    </panel>
  </div>
</div>

<!-- ====== MODAL CATÁLOGO ====== -->
<ng-template #modalMenu let-c="close" let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700">{{ menuForm.value._id ? 'Editar' : 'Nuevo' }} Menú</span>
  </div>
  <div class="modal-body" [formGroup]="menuForm">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">Título</label>
        <input type="text" class="form-control" placeholder="Título del menú" formControlName="title" />
      </div>
      <div class="col-md-6">
        <label class="form-label">Submenú de</label>
        <ng-select [items]="catalogo" placeholder="— Seleccione —" bindLabel="title" bindValue="_id"
          formControlName="parentId" [clearable]="true" appendTo="body"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label">Icono <small class="text-muted">(FontAwesome)</small></label>
        <input type="text" class="form-control" placeholder="fa fa-users" formControlName="icon" />
      </div>
      <div class="col-md-8">
        <label class="form-label">URL</label>
        <input type="text" class="form-control" placeholder="/ruta/del/menu" formControlName="url" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); saveMenu()" [disabled]="!menuForm.valid">Guardar</button>
  </div>
</ng-template>
